export enum USER_STATUS {
    CREATED = 'created',
    DISAPPROVED = 'disapproved',
    APPROVED = 'approved',
    CONFIRMED = 'confirmed'
}
